import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { NotificationComponent, NotificationHeaderComponent } from '@tdwb/core';
import { InlineIconWrapperComponent } from '../../../inline-icon-wrapper/inline-icon-wrapper.component';
import { HrefDirective } from '../../../../directives/href/href.directive';
import { GamlAttestationAnalytics } from '../../../../services/gaml-attestation/gaml-attestation.analytics';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NotificationComponent,
    NotificationHeaderComponent,
    TranslateModule,
    InlineIconWrapperComponent,
    HrefDirective
  ],
  selector: 'td-wb-gaml-halt-trade-global-notification-banner',
  templateUrl: './gaml-halt-trade-global-notification-banner.component.html'
})
export class GamlHaltTradeGlobalNotificationBannerComponent {
  bannerAnalyticsEventLinkName: string;

  constructor(private gamlAttestationAnalytics: GamlAttestationAnalytics){
    this.bannerAnalyticsEventLinkName = this.gamlAttestationAnalytics.GAML_ATTESTATION_HALT_TRADE_BANNER_EVENT.link.name;
  }
}
